import { useMemo, useState } from 'react';

import { Card } from '../../../components/base/Card';
import { useClipboardCopy } from '../../../hooks/useClipboardCopy';
import useSuperAdminDataPoints from '../../../data/datapoint/superadmin/useSuperAdminDataPoints';
import { TextArea } from '../../../components/base/TextArea';

export function DataPointFinderPage() {
  const { dataPoints } = useSuperAdminDataPoints(
    'aa6bfc6a-66a4-4113-af9a-1d0bdec5b8ae',
    true
  );
  const { CopyToClipboardButton } = useClipboardCopy();
  const [dataPointIds, setDataPointIds] = useState<string>('');

  const dataPointIdArray = dataPointIds
    .split(/[\n,]+/)
    .map((id) => id.trim())
    .filter((id) => id.length > 0);

  const matchingDataPoints = useMemo(
    () =>
      dataPoints?.data?.filter((dp) => dataPointIdArray.includes(dp.id)) ?? [],
    [dataPoints.data, dataPointIdArray]
  );

  return (
    <>
      <Card title="Data Points Finder">
        <div className="my-6 grid grid-cols-3 gap-4">
          <div className="space-y-4">
            <p>Paste a comma or ` /n list of DataPoint ids to look them up </p>
            <TextArea
              value={dataPointIds}
              onChange={(e) => setDataPointIds(e.currentTarget.value)}
              placeholder="Enter DataPoint IDs"
              rows={12}
            />
            {/* Print formatted IDs */}
            {dataPointIdArray.length > 0 && (
              <div className="mt-2">
                <div className="text-xs text-gray-500">Formatted IDs:</div>
                <pre className="bg-gray-100 dark:bg-gray-800 rounded p-2 text-xs whitespace-pre-wrap">
                  {dataPointIdArray.map((id) => `"${id}"`).join(',\n')}
                </pre>
              </div>
            )}
          </div>
          <div className="col-span-2">
            <div className="block overflow-x-auto overflow-y-hidden">
              <table className="min-w-full table border border-primary/40 divide-y divide-primary dark:border-primary">
                <thead className="bg-primary/40">
                  <tr>
                    <th className="px-3 py-3 text-left text-sm font-semibold">
                      ID
                    </th>
                    <th className="px-3 py-3 text-left text-sm font-semibold">
                      Name
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-primary/40">
                  {matchingDataPoints.length > 0 ? (
                    matchingDataPoints.map((dp, rowIndex) => (
                      <tr
                        key={dp.id}
                        className={
                          (rowIndex % 2 !== 0 ? 'bg-primary/10 ' : '') +
                          (dp.deletedOn
                            ? 'bg-red-400/50 opacity-70 dark:text-white italic'
                            : '')
                        }
                      >
                        <td className="whitespace-nowrap px-3 py-4 text-sm">
                          {dp.id}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm">
                          {dp.name}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2} className="px-3 py-4 text-sm text-center">
                        No matching data points found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}
